import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import RecipeClass from 'Recipe'

class Recipe extends Component {
  constructor (props) {
    super(props)
    const { seed } = props.match.params
    this.state = {
      recipe: new RecipeClass(seed),
      seed
    }
  }
  async componentWillReceiveProps (newProps) {
    if (newProps.match.params.seed !== this.state.seed) {
      await this.setState({
        recipe: new RecipeClass(newProps.match.params.seed),
        seed: newProps.match.params.seed
      })
      this.setState({
        ingredientsList: this.state.recipe.getIngredients(),
        title: this.state.recipe.recipeObj.title,
        prepInstructions: this.state.recipe.getPrepInstructions(),
        cookInstructions: this.state.recipe.getCookInstructions(),
        serveInstructions: this.state.recipe.getServeInstructions()
      })
    }
  }
  componentWillMount () {
    this.setState({
      ingredientsList: this.state.recipe.getIngredients(),
      title: this.state.recipe.recipeObj.title,
      prepInstructions: this.state.recipe.getPrepInstructions(),
      cookInstructions: this.state.recipe.getCookInstructions(),
      serveInstructions: this.state.recipe.getServeInstructions()
    })
  }
  render () {
    const {
      ingredientsList,
      title,
      prepInstructions,
      cookInstructions,
      serveInstructions
    } = this.state
    return (
      <div className='Recipe'>
        <h2>{title}</h2>
        <div className='Recipe-grid'>
          <div className='Recipe-ingredients'>
            <h3>🛍 Ingredienser</h3>
            <ul className='List'>
              {ingredientsList.map(ingredient => (
                <li key={ingredient}>{ingredient}</li>
          ))}
            </ul>
          </div>
          <div className='Recipe-instructions'>
            <h3>🚀 Gör så här</h3>
            <p>
              { prepInstructions }
            </p>
            <p>
              { cookInstructions }
            </p>
            <p>
              { serveInstructions }
            </p>

            <Link to={Math.floor(Math.random() * 50000).toString()}>🤮</Link>
          </div>
        </div>
      </div>
    )
  }
}

export default Recipe



// WEBPACK FOOTER //
// ./src/containers/Recipe/index.js